module.exports = "<h2 id=\"-ffnungszeiten\">ÖFFNUNGSZEITEN</h2>\n<p>MITTWOCH — SAMSTAG<br>VON 19 — 23.30 UHR</p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/opening_de.md
// module id = F2/0
// module chunks = 0